(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('Profile_User', UserProfiles)
        .factory('ObjectTestSetting', ObjectTestSetting)
        .factory('TestSettingTag', TestSettingTag);


    ObjectTestSetting.$inject = ['$resource'];

    function ObjectTestSetting ($resource) {
        var resourceUrl =  'api/object-test-setting/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;

                }
            },
            'getClone': {
                url:'api/object-test-setting/clone/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'checkType': { url:'api/object-test-setting/checkType', method: 'GET', isArray: true},
            'aggregations': { url:'api/object-test-setting/aggregations', method: 'GET', isArray: true},
            'notManualTests': { url:'api/object-test-setting/not-manual', method: 'GET', isArray: true},
            'update': { method:'PUT' },
            'searchTag':{ url:'api/object-test-setting/search-tag', method: 'GET', isArray: true}
        });
    }

    TestSettingTag.$inject = ['$resource'];

    function TestSettingTag($resource) {
        var resourceUrl = 'api/test-setting-tag/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'byDomain': {method: 'GET', url:'api/test-setting-tag/by-domain', isArray: true},
            'customByDomain': {method: 'GET', url:'api/test-setting-tag/custom-by-domain', isArray: true},
            'getUserProfile': {method: 'GET', url:'api/user-profiles', isArray: true},
            'create': {method: 'POST', url:'api/test-setting-tag/create-new'},
            'update': {method: 'PUT', url:'api/test-setting-tag/update-tag'}
        });
    }
    UserProfiles.$inject = ['$resource'];

    function UserProfiles($resource){
        var resourceUrl = 'api/user-profiles';
        return $resource(resourceUrl, {},{
            'getUserProfile': {method: 'GET', url:'api/user-profiles', isArray: true}
        });
    }

})();
